import { useNavigate } from "react-router-dom";
import { ERROR_404 } from "@/constants";
import Navbar from "@/components/navbar";
import { Button } from "@/components/ui/button";
import Footer from "@/pages/landing/footer";

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)] bg-black text-white flex items-center justify-center mt-16">
        <div className="container mx-auto px-4 py-16 text-center">
          <div className="space-y-8 max-w-2xl mx-auto">
            {/* Error Code */}
            <h1 className="text-9xl font-bold bg-gradient-to-r from-brand-accent to-pink-500 bg-clip-text text-transparent">
              {ERROR_404.title}
            </h1>

            {/* Title */}
            <h2 className="text-4xl font-bold">{ERROR_404.subtitle}</h2>

            {/* Description */}
            <p
              className="text-gray-400 text-lg"
              dangerouslySetInnerHTML={{ __html: ERROR_404.description }}
            />

            {/* Action Button */}
            <div className="pt-8">
              <Button
                onClick={() => navigate("/")}
                size="lg"
                className="rounded-lg px-8 py-4 bg-brand-accent hover:bg-brand-accent/80 text-black"
              >
                {ERROR_404.button}
              </Button>
            </div>

            {/* Decorative Element */}
            <div className="absolute inset-0 -z-10 overflow-hidden">
              <div className="absolute left-[40%] top-[40%] h-[300px] w-[300px] rounded-full bg-[radial-gradient(circle_at_center,rgba(240,167,214,0.15),transparent_70%)]" />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default NotFoundPage;
